import { Account, AccountBalance } from '@monorepo/types';
import { shouldDisablePolling } from '../../utils/polling-utils';
import {
  ACCOUNT_QUERY_KEYS,
  ACCOUNT_STALE_TIME,
  TRADES_POLLING_INTERVAL,
} from '../constants';

/**
 * Creates a React Query configuration for fetching account balance data.
 *
 * @param accountStore - The account store instance with getBalance method
 * @param account - The account to fetch balance data for
 * @returns React Query configuration object
 */
export const createAccountBalanceQuery = (
  accountStore: {
    getBalance: (tsAccountId: string) => Promise<AccountBalance>;
  },
  account: Account | undefined,
) => {
  const shouldDisable = shouldDisablePolling(account);

  return {
    queryKey: ACCOUNT_QUERY_KEYS.ACCOUNT_BALANCE(account?.tsAccountId || ''),
    queryFn: async (): Promise<AccountBalance> => {
      if (!account?.tsAccountId) throw new Error('Account ID is required');

      return await accountStore.getBalance(account.tsAccountId);
    },
    refetchInterval: shouldDisable ? false : TRADES_POLLING_INTERVAL,
    refetchIntervalInBackground: false,
    staleTime: ACCOUNT_STALE_TIME,
    enabled: !!account?.tsAccountId,
  } as const;
};
